const StarzplayerConstants = require('../../starzplayer_constants');
var safe = require('../../util/safe');
var browser = require('../browser/browser');
var feed = require('../feed/feed');
var config = require('../../config');
var pkg = require('../../../package.json');

export default {
    youbora: {},

    hookAnalytics: function(adapter, options) {

        safe.code(() => {
            let content = options.content;
            let deviceType = browser.getDeviceType();
            let manufacturer = browser.getManufacturer();
            let youboraParams = {
                accountCode: (config.environment === 'production') ? 'parsifalentertainment' : 'parsifaldev',
                enableAnalytics: true,
                username: options.user.globalUserId,
                // transactionCode: (config.environment === 'production') ? feed.getMainTitleId(options.content.feed): 'bitmovin-' + feed.getMainTitleId(options.content.feed),
                transactionCode: (config.environment === 'production') ? options.content.id : 'bitmovin-' + options.content.id,
                resource: content.resource,
                media: {
                    title: content.analyticsInfo.titleEn,
                    duration: content.analyticsInfo.duration,
                    isLive: false
                },
                properties: {
                    filename: options.src.dash,
                    content_metadata: {
                        title: content.analyticsInfo.titleEn,
                        genre: content.analyticsInfo.genre,
                        language: content.language || 'en',
                        duration: content.analyticsInfo.duration,
                        parental: content.ageRestriction,
                        mediaGuid: content.analyticsInfo.mediaGuid,
                        app_version: pkg.version,
                        parentId: feed.getMainTitleId(options.content.feed),
                        season: (content.series.season !== undefined) ? parseInt(content.series.season) : 0,
                        episode: (content.series.episode !== undefined) ? parseInt(content.series.episode) : 0
                    },
                    // quality: content.analyticsInfo.userBitrate,
                    quality: 'HD',
                    content_type: content.trailer ? StarzplayerConstants.TRAILER : content.videoType,
                    device: {
                        manufacturer: manufacturer,
                        type: deviceType,
                        year: '',
                        firmware: browser.currentBrowser().name
                    }
                }
            };
            this.youbora = new $YB.plugins.BitdashVR(adapter.player, youboraParams);

            this.handleOffline();
            this.handleOnline();
        });
    },

    handleOnline: function() {
        window.addEventListener('online', (e) => {
            this.youbora.pingApi.start();
        });
    },

    /**
     * Todo: check if we still use this code
     */
    handleOffline: function() {
        window.addEventListener('offline', (e) => {
            this.youbora.pingApi.stop();
        });
    },

    /**
     * Sends the error to youbora
     * @param {Object} options
     * @param {Object} options.code,
     * @param {Object} options.message,
     * @param {Number} [tries=5] - the amount of tries before giving up
     */
    sendError(options, tries = 5) {
        console.debug('Trying to send error to youbora -- ', options);
        if (this.youbora && this.youbora.errorHandler) {
            this.youbora.errorHandler(options.code, options.message);
        } else if (tries > 0) {
            setTimeout(() => this.sendError(options, tries - 1), 1000);
        } else {
            console.debug('Giving up on sending to youbora');
        }
    },

    stopSending() {
        if (!this.youbora) {
            console.debug('Could not stop sending to youbora: youbora is undefined');
            return;
        }
        console.debug('Youbora - Stop Request sent');
        this.youbora.viewManager.sendStop();
    }
};



// WEBPACK FOOTER //
// ./src/modules/report/youbora.js